import { CheckboxWrapper } from '../../../checkbox/CheckboxWrapper';

export function Acknowledgment({
  defaultChecked,
  onAckChange
}: {
  defaultChecked: boolean;
  onAckChange: (provided: boolean) => void;
}) {
  return (
    <CheckboxWrapper
      dataId='acknowledgment'
      label='I acknowledge that if my network or VPN is down due to any reasons, Hevo will not be
            able to send me alerts related to WAL monitoring.'
      labelClasses='text-secondary text-default'
      checkboxProps={{
        defaultChecked,
        onChange: e => onAckChange(e.target.checked)
      }}
    />
  );
}
